import type { ChangeEvent } from "react";

export interface TotpCodeInputProps {
  value: string;
  onChange: (code: string) => void;
  id?: string;
  autoFocus?: boolean;
  disabled?: boolean;
}

// 6자리 코드 입력칸. 숫자만 남기고, 브라우저·OS 가 SMS/앱의 코드를 채워 줄 수 있게
// autocomplete="one-time-code" 를 둔다. 모양은 공통 .input 그대로다.
export function TotpCodeInput({ value, onChange, id, autoFocus, disabled }: TotpCodeInputProps) {
  function handle(e: ChangeEvent<HTMLInputElement>) {
    onChange(e.target.value.replace(/\D/g, "").slice(0, 6));
  }
  return (
    <input
      className="b-input mtotp-code"
      type="text"
      id={id}
      inputMode="numeric"
      autoComplete="one-time-code"
      pattern="[0-9]{6}"
      maxLength={6}
      value={value}
      onChange={handle}
      placeholder="000000"
      autoFocus={autoFocus}
      disabled={disabled}
      required
    />
  );
}
